<template>

  <div class=" p-3 bg-white">
    <div class="row text-center ">

      <div class=" col-lg-6 ">
        <img class="img-fluid col-lg-8 " src="../../../../../public/course.webp">
      </div>
      <div class="col-lg-6">
        <div class="col-lg-12 text-primary mt-5 "><h3> {{paginationMeta.total}}</h3>
          <div class="col-lg-12 mt-3  text-dark"><h4>دوره های من</h4></div>
        </div>
      </div>


    </div>
  </div>

</template>
<script>
import TableLayout from "../../dashboard/TableLayout";
import Pagination from "../../dashboard/Pagination";
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";

export default {
  name: "MyCourse",
  components: {TableLayout, Pagination,},
  data() {
    return {
      courses: [],
      paginationMeta: [],
      tableAttributes,
      fields: [
        {key: "course", label: "دوره"},
        {key: "action", label: ""}
      ],
    }
  },
  methods: {
    changePage(page) {
      const form = {
        page: page,
        user_id: this.$store.getters['User/getUserId']
      }
      this.setUserCourse(form)
    },
    async setUserCourse(form) {
      const res = await this.$store.dispatch("Course/getUserCourses", form);
      const data = res.data.data;
      this.courses = []

      data.data.forEach(product => {
        product.courses.forEach(course => {
          this.courses.push(course)
        })
      })

      this.paginationMeta = data.meta
    }
  },
  async mounted() {
    const form = {
      page: 1,
      user_id: this.$store.getters['User/getUserId']
    }
    await this.setUserCourse(form)

  },
};
</script>
<style scoped>
.user-courses-background{
  background: #f3f3f3;
}
</style>